/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Upload_CompleteInputs */

const en_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload complete. Submitting job...`)
};

const fr_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement terminé. Envoi de la tâche...`)
};

const de_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload abgeschlossen. Auftrag wird übermittelt...`)
};

const it_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento completato. Invio del lavoro in corso...`)
};

const ru_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка завершена. Отправка задания...`)
};

const es_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga completada. Enviando trabajo...`)
};

const zh_cn2_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传完成。正在提交作业……`)
};

const ja_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード完了。ジョブを送信しています...`)
};

const hi_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपलोड पूरा हो गया। जॉब सबमिट की जा रही है...`)
};

const pt_pt2_ad_upload_complete = /** @type {(inputs: Ad_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload concluído. Enviando trabalho...`)
};

/**
* | output |
* | --- |
* | "Upload complete. Submitting job..." |
*
* @param {Ad_Upload_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_upload_complete = /** @type {((inputs?: Ad_Upload_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Upload_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_upload_complete(inputs)
	if (locale === "de") return de_ad_upload_complete(inputs)
	if (locale === "it") return it_ad_upload_complete(inputs)
	if (locale === "ru") return ru_ad_upload_complete(inputs)
	if (locale === "es") return es_ad_upload_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_upload_complete(inputs)
	if (locale === "ja") return ja_ad_upload_complete(inputs)
	if (locale === "hi") return hi_ad_upload_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_upload_complete(inputs)
	return en_ad_upload_complete(inputs)
});